<template>
    <Head title="Tours"/>
    <div class="w-screen h-screen bg-gray-700 flex overflow-hidden">
        <div class="">
            <nav class="sidebar-nav">
                <ul>
                    <li class="logo bg-gray-800">
                        <Link :href="route('tour.index')" :title="__('rooomguide.index')">
                            <img class="w-full" src="/assets/img/logo.svg" alt="logo">
                        </Link>
                    </li>
                    <li>
                        <Link :href="route('tour.index')" :title="__('tour.index')">
                            <img src="/assets/icons/icon-menu.svg">
                        </Link>
                    </li>
                </ul>
                <ul class="nav-bottom bg-gradient">
<!--                    <li>-->
<!--                        <Link :href="route('tour.index')">-->
<!--                            <img src="/assets/icons/icon-settings.svg">-->
<!--                        </Link>-->
<!--                    </li>-->
                    <li>
                        <form @submit.prevent="logout()" class="text-center">
                           <button type="submit">
                                <img src="/assets/icons/icon-logout.svg">
                           </button>
                        </form>
                    </li>
                </ul>
            </nav>
        </div>

        <div class="h-screen w-full">
            <header class="bg-gray-800 flex justify-between px-8 py-2">
                <!-- title area -->
                <h1 class="text-white mt-3 font-bold">{{ title }}</h1>
                <!-- title area -->
                <Link :href="route('my-area')" style="transform: scale(0.8);">
                    <i class="user-circle"></i>
                </Link>
            </header>
            <div class="content py-4 h-full flex">
                <div class="left-sidebar w-1/5 pr-5">
                   <slot name="left-area"></slot>
                </div>
                <div class="overflow-scroll w-full pb-20 pl-5">
                    <slot></slot>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { Link, Head } from '@inertiajs/inertia-vue3'
import { __ } from '@/locale';

export default {
    props: {
        title: String,
    },
    data() {
        return {
            __
        }
    },
    components: {
        Link,
        Head
    },
    methods:{
        logout() {
            this.$inertia.post(route('logout'));
        },
    }
}
</script>
